<template>
    <div class="inner-page">
<!--         <div class="inner-page__link">
            <a href="#">
                <img src="@/assets/icons/main-lcc_link_1.svg" alt="">
            </a>
            <div>
                <img src="@/assets/icons/main-lcc_link_2.svg" alt="">
                <div class="inner-page__soc">
                    <a href="#">
                        <img src="@/assets/icons/main-llc_soc_1.svg" alt="">
                    </a>
                    <a href="#">
                        <img src="@/assets/icons/main-llc_soc_2.svg" alt="">
                    </a>
                    <a href="#">
                        <img src="@/assets/icons/main-llc_soc_3.svg" alt="">
                    </a>
                </div>
            </div>
            <a href="#">
                <img src="@/assets/icons/main-lcc_link_3.svg" alt="">
            </a>
        </div> -->
        <div class="inner-page__title">
            <h3 v-html='card_info.НаимЮЛСокр'></h3>
            <div class="inner-page__row">
                <div class="info__block">{{ card_info.Активность }}</div>
                <div class="inner-page__text">
                    <p>Дата создания:</p>
                    <p>{{ card_info.ДатаОГРН }}</p>
                </div>
            </div>
        </div>
        <div class="active">
            <h1>Виды деятельности</h1>
            <div class="active__main">
                <h3>Основной</h3>
                <div class="active__item">
                    <div class="active__row">
                        <p>{{ card_info.КодОКВЭД }}</p>
                        <p>{{ card_info.НаимОКВЭД }}</p>
                    </div>
<!--                     <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul> -->
                </div>
            </div>
            <div class="active__dop">
                <h3>Дополнительное ({{ card_info.СвОКВЭДДоп.length }})</h3>
                <div class="active__item" v-for="item in card_info.СвОКВЭДДоп">
                    <div class="active__row">
                        <p>{{ item.КодОКВЭД }}</p>
                        <p>{{ item.НаимОКВЭД }}</p>
                    </div>
<!--                     <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul> -->
                </div>
<!--                 <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div>
                <div class="active__item">
                    <div class="active__row">
                        <p>62.01 </p>
                        <p>Разработка компьютерногопрограммного обеспечения</p>
                    </div>
                    <ul>
                        <li>
                            <p><span>ГРН</span>7157747835612</p>
                        </li>
                        <li>
                            <p><span>Дата внесения в ЕГРЮЛ</span>15.09.2015</p>
                        </li>
                    </ul>
                </div> -->
            </div>
<!--             <ul class="pagination">
                <li class="active">1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
            </ul> -->
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
    import axios from 'axios'
    import { toast } from 'bulma-toast'
    import { mask } from 'vue-the-mask'
    import moment from 'moment';

    export default {
        name: "DopOkved",
        directives: { mask },
        props: {
            card_info: Object,
        },
        components: {

        },
        data() {
            return {

            }
        },
        beforeCreate() {
          this.$store.commit('initializeStore')
        },
        mounted() {

        },
        methods: {

        },
        created() {

        },
        watch: {

        },        
   }
</script>